/**
 * Sets a cookie. (Prefixed name - Geolocation app defines its own global setCookie in minutes.)
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function pnSetCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function pnGetCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/**
 * Runs the callback once the visitor has answered the Shopify cookie banner.
 * If the banner isn't shown to them (already decided, or a region without the banner),
 * the callback runs straight away.
 * @param {Function} callback - What to run.
 */
function pnAfterCookieBanner(callback) {
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    callback();
  };

  const check = () => {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.shouldShowBanner !== 'function') {
      run();
      return;
    }

    const consent = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
    const undecided = !!consent && !consent.marketing && !consent.analytics;

    if (cp.shouldShowBanner() && undecided) {
      document.addEventListener('visitorConsentCollected', run, { once: true });
    } else {
      run();
    }
  };

  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (err) => { if (err) run(); else check(); }
    );
  } else {
    run();
  }
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = 'popname-popup-dismissed';

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (this.querySelector('.alert')) {
          // Newsletter success/error message - always show it
          this.open();
        } else if (!pnGetCookie(this.cookie) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          // Start the delay / exit-intent only after the cookie banner has been answered
          pnAfterCookieBanner(() => {
            if (pnGetCookie(this.cookie)) return;
            if (this.dataset.trigger === 'delay') {
              setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
            } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
              this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
              document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
            }
          });
        }
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !pnGetCookie(this.cookie)) this.open();
      }

      /**
       * Opens the pop-up and remembers it was shown (max once per X days).
       * @param {Element} opener - Element that opened the modal.
       */
      open(opener) {
        super.open(opener);
        if (!Shopify.designMode) {
          pnSetCookie(this.cookie, true, parseInt(this.dataset.dismissDays, 10));
        }
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        pnSetCookie(this.cookie, true, parseInt(this.dataset.dismissDays, 10));
      }
    }

    customElements.define('pop-up', PopUp);
  });
}